import React from 'react';
import { Container, Typography, Grid, CardContent, CardActions, Button, Box, Modal } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import {
  ProjectSection,
  ProjectCard,
  ProjectMedia,
  ProjectTitle,
  TechChip,
  ModalContent,
  ModalImage,
  ModalInfo,
  TechIcon,
  CloseButton,
} from '../styles/ProjectsStyles';
import { projects, techIcons, useProjects } from '../utils/ProjectsUtils';

const ProjectsComp = () => {
  const theme = useTheme();
  const { openModal, selectedProject, handleOpenModal, handleCloseModal } = useProjects();

  return (
    <ProjectSection id="projects">
      <Container maxWidth="lg">
        <Typography variant="h2" align="center" gutterBottom sx={{ 
          fontWeight: 'bold', 
          color: 'white', 
          marginBottom: 8,
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
        }}>
          Projetos
        </Typography>
        <Grid container spacing={4}>
          {projects.map((project, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <ProjectCard elevation={0} onClick={() => handleOpenModal(project)} sx={{
                position: 'relative',
                ...(project.title === 'Nexus API' && {
                  border: '2px dashed rgba(255, 193, 7, 0.5)',
                  animation: 'pulse 2s infinite',
                  '@keyframes pulse': {
                    '0%, 100%': { borderColor: 'rgba(255, 193, 7, 0.3)' },
                    '50%': { borderColor: 'rgba(255, 193, 7, 0.8)' },
                  },
                }),
              }}>
                {project.title === 'Nexus API' && (
                  <Box sx={{
                    position: 'absolute',
                    top: 10,
                    right: 10,
                    backgroundColor: 'rgba(255, 193, 7, 0.9)',
                    color: '#000',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '0.75rem',
                    fontWeight: 'bold',
                    zIndex: 1,
                    animation: 'pulseText 2s infinite',
                    '@keyframes pulseText': {
                      '0%, 100%': { opacity: 1 },
                      '50%': { opacity: 0.7 },
                    },
                  }}>
                    Em andamento
                  </Box>
                )}
                <ProjectMedia image={project.image} title={project.title}>
                  <ProjectTitle variant="h5">{project.title}</ProjectTitle>

                </ProjectMedia>
                <CardContent>
                <Typography variant="body2" color={theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'textSecondary'} sx={{ mb: 2 }}>
                    {project.description}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', mb: 2 }}>
                    {project.technologies.map((tech, i) => (
                      <TechChip key={i} label={tech} size="small" />
                    ))}
                  </Box>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                  {project.title === 'Nexus API' ? (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<GitHubIcon />}
                        disabled
                        sx={{ opacity: 0.5 }}
                      >
                        Código Indisponível
                      </Button>
                      <Button variant="outlined" color="secondary" endIcon={<LaunchIcon />} href={project.demo} target="_blank">
                        Demo
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button variant="contained" color="primary" startIcon={<GitHubIcon />} href={project.github} target="_blank">
                        GitHub
                      </Button>
                      <Button variant="outlined" color="secondary" endIcon={<LaunchIcon />} href={project.demo} target="_blank">
                        Demo
                      </Button>
                    </>
                  )}
                </CardActions>
              </ProjectCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="project-modal-title"
        aria-describedby="project-modal-description"
      >
        <ModalContent>
  <CloseButton onClick={handleCloseModal}>
    <CloseIcon />
  </CloseButton>
  {selectedProject && (
    <>
      <ModalImage 
        src={selectedProject.image} 
        alt={selectedProject.title} 
        style={{
filter: 'none'
        }}
      />

      

              <ModalInfo>
                <Typography id="project-modal-title" variant="h4" component="h2" sx={{ mb: 2, color: theme.palette.mode === 'dark' ? 'white' : 'black' }}>
                  {selectedProject.title}
                </Typography>
                <Typography id="project-modal-description" sx={{ mb: 3, color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.7)' }}>
                  {selectedProject.title === 'Nexus API' ? (
                    <>
                      A Nexus API é uma plataforma social completa que oferece uma ampla gama de funcionalidades para criar uma experiência de rede social rica e interativa. Desenvolvida com tecnologias modernas, a aplicação inclui:
                      <ul>
                        <li>Frontend moderno com Next.js 14 e React</li>
                        <li>Backend robusto com Nest.js</li>
                        <li>Banco de dados MongoDB com Prisma ORM</li>
                        <li>Autenticação segura e autorização</li>
                        <li>Sistema de postagens e comentários</li>
                        <li>Chat em tempo real com Socket.io</li>
                        <li>UI responsiva com Tailwind CSS</li>
                        <li>TypeScript para maior segurança</li>
                        <li>Autenticação de dois fatores</li>
                        <li>Recuperação de senha</li>
                        <li>Envio de e-mails</li>
                      </ul>
                      <p><strong>Observação:</strong> Código fonte não disponível.</p>
                    </>
                  ) : selectedProject.title === 'Finanças Pessoais' ? (
                    <>
                      Este aplicativo de Finanças Pessoais é uma solução completa para gerenciamento financeiro, oferecendo uma ampla gama de funcionalidades para ajudar os usuários a controlar suas finanças de forma eficiente. Desenvolvido com tecnologias modernas, o aplicativo inclui:
                      <ul>
                        <li>Autenticação segura com JWT</li>
                        <li>Gerenciamento de despesas e receitas</li>
                        <li>Criação e acompanhamento de orçamentos</li>
                        <li>Controle de contas e saldos</li>
                        <li>Acompanhamento de investimentos</li>
                        <li>Geração de relatórios financeiros</li>
                        <li>Interface responsiva e intuitiva com Material-UI</li>
                        <li>Backend robusto com Node.js, Express e MongoDB</li>
                      </ul>
                      Este projeto demonstra habilidades avançadas em desenvolvimento full-stack, incluindo arquitetura de software, segurança e design de interfaces de usuário.
                    </>
                  ) : selectedProject.title === 'Jogo da Velha' ? (
                    <>
                      Este Jogo da Velha moderno oferece uma experiência de jogo clássica com um toque contemporâneo. Desenvolvido com HTML, CSS e JavaScript, o jogo apresenta uma interface responsiva e atraente, utilizando Bootstrap para um design limpo e adaptável. Características incluem:
                      <ul>
                        <li>Modo claro/escuro para conforto visual</li>
                        <li>Placar personalizado para acompanhar vitórias</li>
                        <li>Animações suaves para uma experiência interativa</li>
                        <li>Design responsivo para jogar em qualquer dispositivo</li>
                      </ul>
                      O projeto demonstra habilidades em desenvolvimento front-end e design de UI/UX, criando uma versão envolvente de um jogo atemporal.
                    </>
                  ) : selectedProject.title === 'Casino Web' ? (
                    <>
                      Esta plataforma de Casino Web oferece uma experiência de jogo envolvente e realista. Desenvolvida com tecnologias web modernas, a aplicação inclui:
                      <ul>
                        <li>Variedade de jogos de cassino, incluindo roleta, blackjack e caça-níqueis</li>
                        <li>Sistema de apostas interativo</li>
                        <li>Design responsivo para jogar em qualquer dispositivo</li>
                        <li>Animações suaves e efeitos sonoros para uma experiência imersiva</li>
                        <li>Sistema de login e gerenciamento de saldo do usuário</li>
                        <li>Interface intuitiva e atraente</li>
                      </ul>
                      Este projeto demonstra habilidades em desenvolvimento front-end, design de UI/UX e implementação de lógica de jogos complexa usando JavaScript e jQuery.
                    </>
                  ) : selectedProject.title === 'Calculadora' ? (
                    <>
                      Esta Calculadora moderna e interativa oferece uma experiência de usuário aprimorada com design elegante e funcionalidades avançadas. Desenvolvida com React e TypeScript, a aplicação apresenta:
                      <ul>
                        <li>Interface limpa e intuitiva com design responsivo</li>
                        <li>Operações matemáticas básicas e avançadas</li>
                        <li>Histórico de cálculos para fácil referência</li>
                        <li>Animações suaves para melhor feedback visual</li>
                        <li>Modo de tema claro/escuro para conforto visual</li>
                        <li>Código bem estruturado e tipado com TypeScript</li>
                        <li>Estilização moderna usando Styled Components</li>
                      </ul>
                      Este projeto demonstra habilidades em desenvolvimento front-end com React, uso eficiente de TypeScript e criação de interfaces de usuário atraentes e funcionais.
                    </>
                  ) : selectedProject.title === 'Tabuada Interativa' ? (
                    <>
                      A Tabuada Interativa é uma aplicação educacional projetada para tornar o aprendizado e a prática da tabuada divertidos e eficazes. Desenvolvida com React, TypeScript e Redux, a aplicação oferece:
                      <ul>
                        <li>Interface interativa e amigável para crianças e adultos</li>
                        <li>Modos de prática e teste para diferentes níveis de habilidade</li>
                        <li>Acompanhamento de progresso e estatísticas de desempenho</li>
                        <li>Animações e efeitos sonoros para feedback imediato</li>
                        <li>Design responsivo para uso em dispositivos móveis e desktops</li>
                        <li>Gerenciamento de estado eficiente com Redux</li>
                        <li>Código bem estruturado e tipado com TypeScript</li>
                        <li>Estilização moderna e atraente com Styled Components</li>
                      </ul>
                      Este projeto demonstra habilidades em desenvolvimento front-end com React, gerenciamento de estado com Redux, e criação de aplicações educacionais interativas.
                    </>
                  ) : selectedProject.title === 'Urna Eletrônica' ? (
                    <>
                      A Urna Eletrônica é uma aplicação web que simula o processo de votação eletrônica, desenvolvida com Next.js e TypeScript. Principais características incluem:
                      <ul>
                        <li>Interface realista de urna eletrônica</li>
                        <li>Simulação completa do processo de votação</li>
                        <li>Lista de candidatos com fotos e informações</li>
                        <li>Validação de votos e confirmação</li>
                        <li>Renderização do lado do servidor (SSR) para melhor performance</li>
                        <li>Design responsivo utilizando Bootstrap</li>
                        <li>Gerenciamento de estado eficiente</li>
                        <li>Código bem estruturado e tipado com TypeScript</li>
                      </ul>
                      Este projeto demonstra habilidades em desenvolvimento front-end com Next.js, TypeScript, e criação de aplicações interativas e educativas.
                    </>
                  ) : selectedProject.title === 'Filmes Online' ? (
                    <>
                      O Filmes Online é uma plataforma de streaming de filmes e séries que oferece uma experiência completa de catálogo e navegação. Desenvolvida com Next.js, React e TypeScript, a aplicação inclui:
                      <ul>
                        <li>Catálogo completo de filmes e séries com dados do TMDB</li>
                        <li>Filtragem por gênero para facilitar a busca</li>
                        <li>Sistema de paginação eficiente</li>
                        <li>Interface responsiva e moderna</li>
                        <li>Gerenciamento de estado com TanStack Query</li>
                        <li>Busca dinâmica e otimizada</li>
                        <li>Design atraente com cards informativos</li>
                        <li>Código bem estruturado e tipado com TypeScript</li>
                      </ul>
                      Este projeto demonstra habilidades em desenvolvimento front-end com Next.js, integração de APIs externas, e criação de interfaces de usuário modernas e responsivas.
                    </>
                  ) : (
                    selectedProject.description
                  )}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', mb: 3 }}>
                  {selectedProject.technologies.map((tech, i) => (
                    <TechIcon key={i} src={techIcons[tech]} alt={tech} title={tech} />
                  ))}
                </Box>
                {selectedProject.title !== 'Nexus API' && (
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 'auto' }}>
                    <Button variant="contained" color="primary" startIcon={<GitHubIcon />} href={selectedProject.github} target="_blank">
                      GitHub
                    </Button>
                    <Button variant="outlined" color="secondary" endIcon={<LaunchIcon />} href={selectedProject.demo} target="_blank">
                      Demo
                    </Button>
                  </Box>
                )}
                {selectedProject.title === 'Nexus API' && (
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'auto' }}>
                    <Button variant="outlined" color="secondary" endIcon={<LaunchIcon />} href={selectedProject.demo} target="_blank">
                      Ver Demo
                    </Button>
                  </Box>
                )}
              </ModalInfo>
            </>
          )}
        </ModalContent>
      </Modal>
    </ProjectSection>
  );
};

export default ProjectsComp;
